import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Auth } from "aws-amplify";
import "./Login.css";
import Box from "@mui/material/Box";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { Backdrop, CircularProgress } from "@mui/material";
import errorMessages from "../../utils/errorMessagesUtil";
import { useForm } from "react-hook-form";
import { useAppProviderStore } from "store/appProviderCopyStore";
import { useNotification } from "hooks/useNotification";

function SendCodeForgotPassword() {
  const navigate = useNavigate();

  const { setinputEmailForgotPassword } = useAppProviderStore();
  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState("");
  const { setNotify } = useNotification();

  const backToLogin = async () => {
    try {
      navigate("/login");
    } catch (err) {
      console.log(err);
    }
  };

  const {
    register,
    formState: { errors },
    trigger,
  } = useForm();

  const handleForgotPassword = async () => {
    setIsLoading(true);
    try {
      await Auth.forgotPassword(email);
      setinputEmailForgotPassword(email);
      navigate("/forgotPasswordComplete");
      setIsLoading(false);
    } catch (err) {
      console.log(err);
      setNotify({
        isOpen: true,
        message: errorMessages[err.message],
        type: "error",
        title:"Ops! Algo deu errado..."
    })
      setIsLoading(false);
    }
  };
  const enterPresskey=(event)=> {
    if (event.keyCode === 13) {
      handleForgotPassword()
    }
  }

  return (
    <div className="container_login" style={{ backgroundImage: "url(/img/bg-login.png)" }}>
      <div className="line_header_login"></div>
      <div className="login">
        <div className="login_logo">
          <img src="/img/Logo_SescDigital_Pos.svg" alt="Logo" className="login_image" />
        </div>
        <div className="login_form">
          <div className="login_form_items">
            <p className="login_form_titulo">Digite seu e-mail</p>
            <div className="real_form">
              <Backdrop open={isLoading} style={{ zIndex: 9999 }} >
                <CircularProgress color="inherit" />
              </Backdrop>
              <Box sx={{ lg: 1, width: "100%" }} onKeyDown={(e) => enterPresskey(e)} >
                <FormControl sx={{ lg: 1, width: "90%", marginBottom: "5%" }} variant="standard">
                  <InputLabel htmlFor="standard-adornment-email">E-mail</InputLabel>
                  <Input id="standard-adornment-email" type="email"  name='email' placeholder="Digite seu e-mail" 
                  //onChange={(evt) => setEmail(evt.target.value)} 
                  {...register("email", {
                     onChange: (e) => {setEmail(e.target.value); trigger(e.target.name)},
                      required: true,
                      pattern:
                        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                    })}
                    aria-invalid={errors.email ? "true" : "false"}
                    onBlur={(evt) => {trigger(evt.target.name);}}
                  />
                  {errors.email?.type === "required" && (
                    <p className="authFormError" role="alert">
                       Campo obrigatório.
                    </p>
                  )}
                  {errors.email?.type === "pattern" && (
                    <p className="authFormError" role="alert">
                      Formato de usuário/email invalido.
                    </p>
                  )}
                </FormControl>
              </Box>
            </div>
            <div className="login_button">
              <button className="login_button_style" onClick={handleForgotPassword}>
                Confirmar
              </button>
            </div>
            <div className="login_forgot_password">
              <a className="login_forgot_password_text" onClick={backToLogin}>
                Voltar para o Login
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="line_bottom_login"></div>
    </div>
  );
}

export default SendCodeForgotPassword;
